import { put, takeEvery, call } from "redux-saga/effects";

import * as apis from "../../network/apis/lookups";
import {
  getAreasResponse,
  getCarMakesResponse,
  getCarModelsResponse,
  getCarTypesResponse,
  getCitiesResponse,
  getDriversResponse,
  getLevelsResponse,
  getMaintenanceTypesResponse,
  getStationsResponse,
  getTeamsResponse,
  getVerificationRequestsRejectionReasonsResponse,
  getChallengeSignalTypesResponse,
} from "./slice";
import { showSnackMsg } from "../../utils/Helpers";
import { City } from "../../models/city.model";
import { Area } from "../../models/area.model";
import { setSkeletonObject } from "../Loader/slice";
import { CarModel } from "../../models/carModel.model";
import store from "..";
import messages from "../../assets/locales/messages";
import { Station } from "../../models/station.model";

export function* getCitiesSaga({ payload }) {
  try {
    yield put(setSkeletonObject({ field: "cities", value: true }));
    const response = yield call(apis.getCities, payload);
    const cities = City.setCities(response.data?.data);
    yield put(getCitiesResponse(cities));
    yield put(setSkeletonObject({ field: "cities", value: false }));
  } catch (err) {
    yield put(setSkeletonObject({ field: "cities", value: false }));
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export function* getAreasSaga({ payload }) {
  try {
    yield put(setSkeletonObject({ field: "areas", value: true }));
    const response = yield call(apis.getAreas, payload);
    const areas = Area.setAreas(response.data?.data);
    yield put(getAreasResponse(areas));
    yield put(setSkeletonObject({ field: "areas", value: false }));
  } catch (err) {
    yield put(setSkeletonObject({ field: "areas", value: false }));
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export function* getCarMakesSaga({ payload }) {
  try {
    const { payload: reqParams, addAllOption } = payload;
    yield put(setSkeletonObject({ field: "carMakes", value: true }));
    const response = yield call(apis.getCarMakes, reqParams);
    //add all car makes option
    const locale = store.getState().locale.locale;
    const allCarMakesOption = {
      id: -1,
      name: messages[locale].offers.offerForm.all,
    };
    yield put(
      getCarMakesResponse(
        addAllOption
          ? [allCarMakesOption, ...response.data?.vehicle_brands]
          : response.data?.vehicle_brands
      )
    );
    yield put(setSkeletonObject({ field: "carMakes", value: false }));
  } catch (err) {
    yield put(setSkeletonObject({ field: "carMakes", value: false }));
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export function* getCarTypesSaga({ payload }) {
  try {
    const { payload: reqParams, addAllOption } = payload;
    yield put(setSkeletonObject({ field: "carTypes", value: true }));
    const response = yield call(apis.getCarTypes, reqParams);
    //add all car types option
    const locale = store.getState().locale.locale;
    const allCarTypesOption = {
      id: -1,
      name: messages[locale].offers.offerForm.all,
    };
    yield put(
      getCarTypesResponse(
        addAllOption
          ? [allCarTypesOption, ...response.data?.vehicle_types]
          : response.data?.vehicle_types
      )
    );
    yield put(setSkeletonObject({ field: "carTypes", value: false }));
  } catch (err) {
    yield put(setSkeletonObject({ field: "carTypes", value: false }));
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export function* getCarModelsSaga({ payload }) {
  try {
    yield put(setSkeletonObject({ field: "carModels", value: true }));
    const response = yield call(apis.getCarModels, payload);
    const carModels = CarModel.setCarModels(response.data?.data);
    yield put(getCarModelsResponse(carModels));
    yield put(setSkeletonObject({ field: "carModels", value: false }));
  } catch (err) {
    yield put(setSkeletonObject({ field: "carModels", value: false }));
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export function* getStationsSaga({ payload }) {
  try {
    yield put(setSkeletonObject({ field: "stations", value: true }));
    const response = yield call(apis.getStations, payload);
    const stations = Station.setStations(response?.data?.stations);
    yield put(getStationsResponse(stations));
    yield put(setSkeletonObject({ field: "stations", value: false }));
  } catch (err) {
    yield put(setSkeletonObject({ field: "stations", value: false }));
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export function* getTeamsSaga({ payload }) {
  try {
    yield put(setSkeletonObject({ field: "teams", value: true }));
    const response = yield call(apis.getTeams, payload);
    const teams = response?.data?.owners;
    yield put(
      getTeamsResponse({
        teams,
        page: payload.page,
        lastPageCount: +response.headers["total-pages"],
      })
    );
    yield put(setSkeletonObject({ field: "teams", value: false }));
  } catch (err) {
    yield put(setSkeletonObject({ field: "teams", value: false }));
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export function* getDriversSaga({ payload }) {
  try {
    yield put(setSkeletonObject({ field: "drivers", value: true }));
    const response = yield call(apis.getDrivers, payload);
    const drivers = response?.data?.drivers;
    yield put(
      getDriversResponse({
        drivers,
        page: payload.page,
        lastPageCount: +response.headers["total-pages"],
      })
    );
    yield put(setSkeletonObject({ field: "drivers", value: false }));
  } catch (err) {
    yield put(setSkeletonObject({ field: "drivers", value: false }));
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export function* getLevelsSaga({ payload }) {
  try {
    yield put(setSkeletonObject({ field: "levels", value: true }));
    const response = yield call(apis.getLevels, payload);
    const levels = response.data?.levels;
    yield put(getLevelsResponse(levels));
    yield put(setSkeletonObject({ field: "levels", value: false }));
  } catch (err) {
    yield put(setSkeletonObject({ field: "levels", value: false }));
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export function* getMaintenanceTypesSaga({ payload }) {
  try {
    yield put(setSkeletonObject({ field: "maintenanceTypes", value: true }));
    const response = yield call(apis.getMaintenanceTypes, payload);
    const maintenanceTypes = response.data?.maintenance_types;
    yield put(getMaintenanceTypesResponse(maintenanceTypes));
    yield put(setSkeletonObject({ field: "maintenanceTypes", value: false }));
  } catch (err) {
    yield put(setSkeletonObject({ field: "maintenanceTypes", value: false }));
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export function* getVerificationRequestsRejectionReasonsSaga({ payload }) {
  try {
    yield put(setSkeletonObject({ field: "rejectionReasons", value: true }));
    const response = yield call(
      apis.getVerificationRequestsRejectionReasons,
      payload
    );
    const reasons = response.data?.verification_rejection_reasons;
    yield put(getVerificationRequestsRejectionReasonsResponse(reasons));
    yield put(setSkeletonObject({ field: "rejectionReasons", value: false }));
  } catch (err) {
    yield put(setSkeletonObject({ field: "rejectionReasons", value: false }));
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export function* getChallengeSignalTypesSaga({ payload }) {
  try {
    const response = yield call(apis.getChallengeSignalTypes, payload);
    const signalTypes = response.data?.challenge_templates ?? [];
    yield put(getChallengeSignalTypesResponse(signalTypes));
  } catch (err) {
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export default function* LookupsSagas() {
  yield takeEvery("lookups/getCitiesRequest", getCitiesSaga);
  yield takeEvery("lookups/getAreasRequest", getAreasSaga);
  yield takeEvery("lookups/getCarMakesRequest", getCarMakesSaga);
  yield takeEvery("lookups/getCarTypesRequest", getCarTypesSaga);
  yield takeEvery("lookups/getCarModelsRequest", getCarModelsSaga);
  yield takeEvery("lookups/getStationsRequest", getStationsSaga);
  yield takeEvery("lookups/getTeamsRequest", getTeamsSaga);
  yield takeEvery("lookups/getDriversRequest", getDriversSaga);
  yield takeEvery("lookups/getLevelsRequest", getLevelsSaga);
  yield takeEvery("lookups/getMaintenanceTypesRequest", getMaintenanceTypesSaga);
  yield takeEvery(
    "lookups/getVerificationRequestsRejectionReasonsRequest",
    getVerificationRequestsRejectionReasonsSaga
  );
  yield takeEvery(
    "lookups/getChallengeSignalTypesRequest",
    getChallengeSignalTypesSaga
  );
}
